import React from 'react';
import Image from 'react-bootstrap/Image';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Table from 'react-bootstrap/Table';
import Tabla from '../Tabla';
import MatchList from '../MatchList';
import MatchCardGroup from '../MatchCardGroup';
import Players from '../Players';
import ToggleButtonGroup from 'react-bootstrap/ToggleButtonGroup';
import ToggleButton from 'react-bootstrap/ToggleButton';
class Campeonato2024 extends React.Component {

  constructor(props){
    super(props);
        this.comeBack = this.comeBack.bind(this);
	this.handleChange = this.handleChange.bind(this);
	var id_list = [];
	for (var i = 158; i <= 181; i++) {
        	id_list.push(i);
        }
    this.state = {
	showCards: true,
      path: this.props.path,
	kits:[],
        kit_path: '/images_fem/kits/todas/',
      ctype: this.props.ctype,
      torneo: this.props.torneo,
      id_list: id_list,

	table2:[{'color':0,'shortname':'udeconce', 'rivalName':'U. de Concepción', 'pj':24, 'pg':7,'pe':2,'pp':15,'gf':24,'gc':49,'dif':-25, 'pts':23},
              {'color':'#295e1e','shortname':'iquique', 'rivalName':'Dep. Iquique', 'pj':24, 'pg':10,'pe':6,'pp':8,'gf':29,'gc':27,'dif':2, 'pts':36},
              {'color':'#295e1e','shortname':'coquimbo', 'rivalName':'Coquimbo U.', 'pj':24, 'pg':12,'pe':6,'pp':6,'gf':49,'gc':34,'dif':15, 'pts':42},
              {'color':'#295e1e','shortname':'everton', 'rivalName':'Everton', 'pj':24, 'pg':6,'pe':6,'pp':12,'gf':28,'gc':43,'dif':-15, 'pts':24},
              {'color':'#E42727','shortname':'cobresal', 'rivalName':'Cobresal', 'pj':24, 'pg':3,'pe':5, 'pp':16,'gf':22,'gc':62,'dif':-40, 'pts':14},
              {'color':'#295e1e','shortname':'colocolo', 'rivalName':'Colo Colo', 'pj':24, 'pg':20,'pe':3,'pp':1,'gf':84,'gc':9,'dif':75, 'pts':63},
              {'color':'#295e1e','shortname':'udechile', 'rivalName':'U. de Chile', 'pj':24, 'pg':20,'pe':2,'pp':2,'gf':83,'gc':17,'dif':66, 'pts':62},
                {'color':0,'shortname':'palestino', 'rivalName':'Palestino', 'pj':24, 'pg':6,'pe':6,'pp':12,'gf':26,'gc':56,'dif':-30, 'pts':24},
                {'color':0,'shortname':'audax', 'rivalName':'A. Italiano', 'pj':24, 'pg':5,'pe':4,'pp':15,'gf':24,'gc':57,'dif':-33, 'pts':19},
                {'color':'#295e1e','shortname':'catolica', 'rivalName':'U. Católica', 'pj':24, 'pg':11,'pe':7,'pp':6,'gf':43,'gc':33,'dif':10, 'pts':40},
                {'color':'#E42727','shortname':'antofagasta', 'rivalName':'Antofagasta', 'pj':24, 'pg':3,'pe':3,'pp':18,'gf':24,'gc':71,'dif':-47, 'pts':12},
                {'color':'#295e1e','shortname':'morning', 'rivalName':'S. Morning', 'pj':24, 'pg':15,'pe':4,'pp':5,'gf':61,'gc':33,'dif':28, 'pts':49},
              {'color':'#295e1e','shortname':'union', 'rivalName':'U. Española', 'pj':24, 'pg':7,'pe':8,'pp':9,'gf':30,'gc':36,'dif':-6, 'pts':29}]






    };
  }

  componentDidMount() {
		this.getKits();
		let newtable = this.sortTable(this.state.table2);
  		this.setState({table2:newtable});
	}
 getKits(){

        fetch("https://www.registrosudec.com:5000/kits_femenino", {

    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      id_list: this.state.id_list
    })
    }).then(
                res => res.json()
                )
  .then(
    (result) => {
        console.log(result)
        this.setState({ 
        kits: result['kits']}) //[{path:"45.png", kit:yellow, short:"blue", socks:"blue", count:15, 
    },
    // Nota: es importante manejar errores aqu   y no en
    // un bloque catch() para que no interceptemos errores
    // de errores reales en los componentes.
    (error) => {
      console.log(error);
      this.setState({fecha: []})
    }
  );
}




  handleChange(val){
    console.log(val);
    if(val===1){
      this.setState({showCards:true});
    }
    else{
      this.setState({showCards:false});
    }
  }

comeBack(){
this.setState({path:this.state.path});
}

subText(color, text){

let comp = [];
comp.push(

	<Row className="justify-content-md-center">
            <Col lg={2} xl={2} >

        <Table bordered={ false } size="sm">
        <tr style={{border: 'none', textAlign: 'rigth' }}>
        <td bgcolor={color}>
        </td>
        <td style={{border: 'none', textAlign: 'center'}}> {text} </td>
        </tr>
        </Table>
        </Col>
        </Row>



)
return comp;

}


sortTable(table){
       let aux;
      for(let i=table.length-1;i>0;i--){
             for(let j =0; j<i; j++){
                 if( (table[j].pts < table[j+1].pts) || 
                     ((table[j].pts === table[j+1].pts) && (table[j].dif < table[j+1].dif)) ||
                     ((table[j].pts === table[j+1].pts) && (table[j].dif === table[j+1].dif) && (table[j].gf < table[j+1].gf))){
			aux = table[j+1];
			table[j+1] = table[j];
                        table[j] = aux;
		} 
	     }		
	}
return table;

}


render(){


  let subT = this.subText('#295e1e', 'Clasificado a Play-Off');
  let subC = this.subText('#E42727', 'Desciende a Primera B');
  return(

	<div style={{textAlign: 'center' }}>
	      <div style={{ height: '50px' }}></div>
        <div className="mytitlepartidos">  Indumentaria UDEC Campeonato 2024</div>
        <div style={{ height: '50px' }}></div> 

        <div style={{display: 'inline-block' }}>
        <table style={{textAlign: 'center' }}>
        <tr>
           {this.state.kits.map((i) => {
                   return ( <td> <Image  className="escudo-home" src={this.state.kit_path+i['path']+".png"}/> </td>)
            })}
        </tr>
        <tr>
        {this.state.kits.map((i) => {
                   return ( <td> <Image  className="myshort" src={this.state.kit_path+i['short']+".png"}/> </td>)
            })}
        </tr>
        <tr>
        {this.state.kits.map((i) => {
                   return ( <td> <Image  className="myshort" src={this.state.kit_path+'socks-'+i['socks']+".png"}/> </td>)
            })}
        </tr>

        <tr>
                {this.state.kits.map((i) => {
                   return ( <td class="circle"> {i['count']} </td>)
            })}
        </tr>
        </table>
        </div>

      <div style={{ height: '50px' }}></div>
	<div className="mytitlepartidos"> Tabla General </div>
	<div style={{ height: '10px' }}></div>
	{<Tabla teams={this.state.table2} />}
        <div style={{ height: '10px' }}></div>
         {subT}
	{subC}


	
	<div style={{ height: '100px' }}></div>
	<div className="mytitlepartidos">  Partidos UDEC Campeonato 2024</div>
	<div style={{ height: '10px' }}></div>

	<ToggleButtonGroup type="radio" name="options" defaultValue={1} onChange={this.handleChange}>
            <ToggleButton variant="secondary" value={1}>Tarjetas</ToggleButton>
            <ToggleButton variant="secondary" value={2}>Listado</ToggleButton>
          </ToggleButtonGroup>
	 <div style={{ height: '10px' }}></div>
	<Container>
	<div className={this.state.showCards ? '': 'hiddenCard'}>
           <MatchCardGroup id_list={this.state.id_list}></MatchCardGroup>
         </div>
         <div className={this.state.showCards ? 'hiddenCard': ''}>

           <MatchList id_list={this.state.id_list} showName={true}></MatchList>

         </div>
	</Container>

	<div style={{ height: '100px' }}></div>
        <div className="mytitlepartidos">  Jugadores UDEC Campeonato 2024</div>
        <div style={{ height: '10px' }}></div>

	<Players torneo="Campeonato 2024" />
     </div>


  )
}

}
export default Campeonato2024;
